import { createSlice } from '@reduxjs/toolkit';

import { BLACKLIST_ADD_MODAL_STAGES } from '@communicationManagement/data/blacklistAddModalStages';
import { BLACKLIST_MANAGE_MODAL_STAGES } from '@communicationManagement/data/blacklistManageModalStages';

const initialState = {
  personalisedMenteeEmailersAddModalStage: BLACKLIST_ADD_MODAL_STAGES.close,
  personalisedMenteeEmailersManageModalStage:
    BLACKLIST_MANAGE_MODAL_STAGES.close,
  currentPage: 1,
  manageSnoozeLearner: null,
  confirmSnoozeLearnerData: null,
  inputErrors: null,
};

export const blacklistLearners = createSlice({
  name: 'blacklistLearners',
  initialState,
  reducers: {
    setPersonalisedMenteeEmailersCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },
    setPersonalisedMenteeEmailersManageModalStage: (state, action) => {
      state.personalisedMenteeEmailersManageModalStage = action.payload;
    },
    setPersonalisedMenteeEmailersAddModalStage: (state, action) => {
      state.personalisedMenteeEmailersAddModalStage = action.payload;
    },
    setBlacklistedMenteeManageLearner: (state, action) => {
      state.manageSnoozeLearner = action.payload;
    },
    setInputErrors: (state, action) => {
      state.inputErrors = action.payload;
    },
  },
});

export const {
  setPersonalisedMenteeEmailersCurrentPage,
  setPersonalisedMenteeEmailersManageModalStage,
  setPersonalisedMenteeEmailersAddModalStage,
  setBlacklistedMenteeManageLearner,
  setInputErrors,
} = blacklistLearners.actions;

export default blacklistLearners.reducer;
